export default __webpack_public_path__ + "static/media/magic-circle-tc.2440b5a0.svg";